// removed by extract-text-webpack-plugin
module.exports = {"root":"_1_xo"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Layout/Col/Col.css
// module id = pf+D
// module chunks = 0